import SolutionsProvider from '~providers/solutions';
import SolutionsTable from '~components/solutions-table/solutions-table';
import GlobeTrafficAnimation from "~components/globe-traffic-animation/globe-traffic-animation";
import * as React from 'react';
export default {
  SolutionsProvider,
  SolutionsTable,
  GlobeTrafficAnimation,
  React
};